/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Newsletter_DisclaimerInputs */

const en_directory_home_newsletter_disclaimer = /** @type {(inputs: Directory_Home_Newsletter_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No spam. Unsubscribe anytime.`)
};

const zh_directory_home_newsletter_disclaimer = /** @type {(inputs: Directory_Home_Newsletter_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不发垃圾邮件，随时可取消订阅。`)
};

/**
* | output |
* | --- |
* | "No spam. Unsubscribe anytime." |
*
* @param {Directory_Home_Newsletter_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_newsletter_disclaimer = /** @type {((inputs?: Directory_Home_Newsletter_DisclaimerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Newsletter_DisclaimerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_newsletter_disclaimer(inputs)
	return zh_directory_home_newsletter_disclaimer(inputs)
});
export { directory_home_newsletter_disclaimer as "directory.home.newsletter_disclaimer" }